import React from "react";

const LoadingSpinner = () => {
  const isMobile = window.innerWidth <= 768;
  const size = isMobile ? 100 : 150; 

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "#ffffff",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
     <img
  src="/images/loader2.gif"
  alt="Loading"
  style={{
    width: `${size}px`,
    height: `${size}px`,
    objectFit: "cover",
    
    // हे लाल रंग तुमच्या #4B0082 (Deep Indigo) शेडमध्ये बदलण्यासाठी
    filter: "hue-rotate(272deg) saturate(1.8) brightness(95%)"
  }}
/>
    </div>
  );
};

export default LoadingSpinner;
